// extracted by mini-css-extract-plugin
module.exports = {"list":"Mobile_list__pc4Mn"};